import firebase from '../firebase/firebase';
import {
    types
} from './types';
import {
    toArray
} from '../utils/lodashUtils';


const db = firebase.database();

const clientData = {}

const tryCatch = (cb) => {
    try {
        cb()
    } catch (error) {
        console.log('FIREBASE ERROR:', error);
    }
};

export const getClientData = (userId, cb = null) => async (dispatch, getState) => {
    // YOU CAN THINK OF THIS AS GET USER DATA - IT GRABS THE DATA OF THE CURRENTLY LOGGED USER

    // CLIENT DATA IS LOADED ONE PIECE AT A TIME
    // SO THAT CLIENTS CAN GIVE CONSENT TO WHICH INFO IS SHARED WITH WHOM
    // AND FIREBASE CASCADING DATA RULES CAN BE APPLIED ACCORDINGLY
    // console.log('Getting cLient Data')
    return new Promise(async (resolve, reject) => {
        if (userId) {
            try {
                // GET PROFILE INFO
                const profileSnap = await db.ref(`/clients/${userId}/basicProfile`).once('value');
                // PROFILE SHOULD INCLUDE NAME AND PHOTO
                const profile = profileSnap.val();
                if (profile) {
                    clientData.firstName = profile.firstName;
                    clientData.lastName = profile.lastName;
                    if (profile.profilePhotoURL) clientData.profilePhotoURL = profile.profilePhotoURL;
                }

                // GET CLIENT PHONE NUMBER
                const phoneSnap = await db.ref(`/clients/${userId}/phone`).once('value');
                if (phoneSnap.val()) clientData.phone = phoneSnap.val();

                // GET CLIENT EMAIL
                const emailSnap = await db.ref(`/clients/${userId}/email`).once('value');
                if (emailSnap.val()) clientData.email = emailSnap.val();

                // GET CLIENT ROLE
                const roleSnap = await db.ref(`/clients/${userId}/roles`).once('value');
                if (roleSnap.val()) clientData.roles = roleSnap.val();

                // GET SBM CLIENT ID
                const sbmClientIdSnap = await db.ref(`/clients/${userId}/SBMClientId`).once('value')
                if (sbmClientIdSnap.val()) clientData.SBMClientId = sbmClientIdSnap.val(); // null for provider users

                // GET TEMP PASS IF ANY
                // const tempPassSnap = await db.ref(`/clients/${userId}/tempPass`).once('value')
                // if (tempPassSnap.val()) clientData.tempPass = tempPassSnap.val(); // only present for non-activated accounts

                try {
                    // console.log('GETTING ACTIVATION STATUS')
                    // GET CLIENT PENDING ACTIVATION STATUS
                    const pendingAccountIdSnap = await db.ref(`/clients/${userId}/pendingAccountId`).once('value')
                    if (pendingAccountIdSnap.val()) {
                        // console.log('GOT PENDING ACTIVATION STATUS TRUE')
                        clientData.isPendingActivation = true;
                    } else {
                        clientData.isPendingActivation = false;
                        // console.log('GOT PENDING ACTIVATION STATUS false', pendingAccountIdSnap.val())
                    }
                } catch (e) {
                    console.log(e, 'Could not get activation status.')
                }

                // GET CREDITS
                const creditsSnap = await db.ref(`/clients/${userId}/credits`).once('value');
                if (creditsSnap.val()) clientData.credits = creditsSnap.val(); // null for provider users

                // GET SERVICE PROVIDERS
                const serviceProvidersSnap = await db.ref(`/clients/${userId}/serviceProviders`).once('value');
                if (serviceProvidersSnap.val()) clientData.serviceProviders = toArray(serviceProvidersSnap.val()); // null for provider users

                // GET MESSAGE THREADS
                const messageThreadRef = db.ref(`/clients/${userId}/messageThreads`);
                // messageThreadRef.off();
                const messageThreadsSnap = await messageThreadRef.once('value');
                if (messageThreadsSnap.val()) clientData.messageThreads = toArray(messageThreadsSnap.val()); // null for provider users


                // GET CLIENT PROVIDER PROFILES
                const clientProvidersRef = db.ref(`/clients/${userId}/serviceProviders`);
                const clientProvidersSnap = await clientProvidersRef.once('value');
                // console.log('CLIENT PRO', clientProvidersSnap, userId, clientProvidersSnap.val());
                if (clientProvidersSnap.val()) {
                    // console.log('CLIENT PRO', clientProvidersSnap.val());
                    clientData.providerProfiles = [];
                    toArray(clientProvidersSnap.val()).map(async clientProvider => {
                        // console.log('CLIENT PRO', clientProvider);
                        let providerProfileSnap = await db.ref(`clients/${clientProvider._id}/basicProfile`).once('value');
                        const providerProfile = providerProfileSnap.val();
                        // console.log('CLIENTs PROVIDER PROFILE', profile);
                        providerProfile.uid = clientProvider._id;
                        clientData.providerProfiles.push(providerProfile);
                    });
                }

                // GET CLIENT SERVICES
                const servicesSnap = await db.ref(`/clients/${userId}/services`).once('value');
                if (servicesSnap.val()) { // null for provider users
                    clientData.services = [];
                    toArray(servicesSnap.val()).map(clientService => {
                        // console.log('CLIENT SERVICE', clientService);

                        let service = {};
                        service._id = clientService._id;
                        service.activePeriods = [];
                        toArray(clientService.activePeriods).map(async activePeriod => {
                            let activePeriodSnap = await db.ref(`activeServicePeriods/${activePeriod._id}`).once('value');
                            // console.log('activePeriod', activePeriodSnap.val());
                            service.activePeriods.push(activePeriodSnap.val());
                            let fullServiceSnap = await db.ref(`services/${service._id}`).once('value');
                            service.name = fullServiceSnap.val().name;
                            service.provider = fullServiceSnap.val().provider;

                        });
                        clientData.services.push(service)
                    });
                } else {
                    clientData.services = null;
                }


                // GET CLIENT BOOKINGS
                clientData.bookings = [];
                const clientBookingsRef = db.ref(`/clients/${userId}/bookings`);
                // clientBookingsRef.off();
                let clientBookingsRefSnap = await clientBookingsRef.once('value');
                if (clientBookingsRefSnap.val() && clientData.bookings.length === 0) {
                    // console.log('bookingrefs', clientBookingsRefSnap.val());

                    toArray(clientBookingsRefSnap.val()).map(async (clientBookingId, i) => {
                        let bookingDataSnap = await db.ref(`bookings/${clientBookingId}`).once('value');
                        // db.ref(`bookings`).orderByChild('clientUid').equalTo.on('child_added', (snap) => {
                        //     dispatch({
                        //         type: types.GET_NEW_CLIENT_BOOKING,
                        //         payload: bookingDataSnap.val(),
                        //     })
                        // });
                        clientData.bookings.push(bookingDataSnap.val());
                        // console.log('CLIENT BOOKING', clientBookingId, bookingDataSnap.val());
                        return;
                    });
                }

                const providerClientsSnap = await db.ref(`/clients/${userId}/clients/`).once('value');
                // console.log('PROVIDER CLIENTS', providerClientsSnap.val());

                if (providerClientsSnap.val()) {
                    // LOOP OVER EACH PROVIDER CLIENT AND GET THE ACTUAL ACTIVE PERIODS AND LOAD THEM INTO THE PROVIDER CLIENTDATA OBJECT
                    clientData.clients = [];
                    toArray(providerClientsSnap.val()).map(async providerClient => {
                        // console.log('providerClient', providerClient);
                        let client = {}
                        client.services = [];
                        client.uid = providerClient._id;
                        let providerProfileSnap = await db.ref(`clients/${providerClient._id}/basicProfile`).once('value');
                        client.firstName = providerProfileSnap.val().firstName;
                        client.lastName = providerProfileSnap.val().lastName;
                        client.profilePhotoURL = providerProfileSnap.val().profilePhotoURL;
                        toArray(providerClient.services).map(providerService => {
                            // console.log('providerService', providerService);
                            let service = {};
                            service._id = providerService._id;
                            service.activePeriods = [];
                            toArray(providerService.activePeriods).map(async activePeriod => {
                                let activePeriodSnap = await db.ref(`activeServicePeriods/${activePeriod._id}`).once('value');
                                // console.log('activePeriod', activePeriodSnap.val());
                                service.activePeriods.push(activePeriodSnap.val());
                            });
                            client.services.push(service)
                        });
                        clientData.clients.push(client)
                    });
                }

                const purchasesSnap = await db.ref(`/clients/${userId}/purchases`).once('value')
                if (purchasesSnap.val()) clientData.purchases = toArray(purchasesSnap.val());

                // const clientsSnap = await db.ref(`/clients/${userId}/clients`).once('value')
                // if (clientsSnap.val()) clientData.clients = clientsSnap.val();

                const uidSnap = await db.ref(`/clients/${userId}/uid`).once('value')
                if (uidSnap.val()) clientData.uid = uidSnap.val();

                const providerSnap = await db.ref(`/clients/${userId}/provider`).once('value')
                if (providerSnap.val()) clientData.provider = providerSnap.val();

                const providerCompanySnap = await db.ref(`/clients/${userId}/providerCompany`).once('value');
                if (providerCompanySnap.val()) clientData.providerCompany = providerCompanySnap.val();

                // console.log('CLIENT DATA DISPATCH', clientData);

                dispatch({
                    type: types.GET_CLIENT_DATA_SUCCESS,
                    payload: clientData
                });
                if (cb) cb();
                resolve(true);
            } catch (error) {
                console.log('FIREBASE ERROR @ CLIENT ACTIONS (getClientData)', error, userId);
                resolve(null);
                dispatch({
                    type: types.GET_CLIENT_DATA_FAIL,
                    payload: null
                });
            }
        } else if (userId === null) { // loads an empty data set into the clientData, essentially wiping it
            dispatch({
                type: types.RESET_CLIENT_DATA,
                payload: null
            });
        }
        resolve(null);
        return null;
    })
}

export const getDBClients = (clientIds) => async dispatch => {
    // let clients = [];
    // const onGetClients = (snap) => {

    //     snap.forEach( provider => {
    //         if (provider){
    //             providers.push(provider.val());
    //         }
    //     });

    //     dispatch ({
    //         type: types.GET_ALL_DB_PROVIDERS,
    //         payload: providers
    //     });
    // }

    // db.ref(`/clients/${clientId}/firstName`).once('value', onGetProviders);
};

// export const listenForUserActivityStatus = (userId) = dispatch => {
//     const userActivityStatusRef = db.ref(`clients/${userId}/activityStatus`);
//     userActivityStatusRef.off();
//     userActivityStatusRef.on('value', (userActivityStatusSnap) => {
//         const userActivityStatus = userActivityStatusSnap.val();

//         dispatch({
//             type: types.GET_USER_ACTIVITY_STATUS_SUCCESS,
//             payload: userActivityStatus
//         })
//     }, (error) => {
//         console.log('FIREBASE ERROR:', error);

//         dispatch({
//             type: types.GET_USER_ACTIVITY_STATUS_FAIL,
//             payload: 'unknown'
//         })
//     });
// }


// WEBPACK FOOTER //
// ./src/js/actions/client-actions.js